import { createSelector } from 'reselect'

const getShouldShowFeedbackBox = state => state.user.extra?.shouldShowFeedbackBox

const userShouldSeeFeedbackBox = createSelector(
	[ getShouldShowFeedbackBox ],
	shouldShowFeedbackBox => shouldShowFeedbackBox !== undefined ? shouldShowFeedbackBox : true
)

export default userShouldSeeFeedbackBox
